<div class="error-month-bill">
  <div class="row">
    <div class="col-10">
      <div class="error-month-bill-icon-text-wrapper">
        <div class="error-month-bill-icon"></div>
        <div class="error-month-bill-text">
          <span [innerHTML]="textTranslationKey | translate : { month: organizationOrCompanyFailedBill?.timestamp | date : 'MMMM' }"></span>
        </div>
      </div>
    </div>

    <div class="col-12 col-lg-2 d-flex align-items-center">
      <div class="w-100 d-flex align-items-center justify-content-between d-lg-block mt-3 mt-lg-0 text-right">
        <button type="submit" class="error-month-bill-button" (click)="payNow.emit()">
          {{ "PAY_NOW" | translate }}
        </button>
      </div>
    </div>
  </div>
</div>
